import { child, set } from 'firebase/database';
import { PiniaPluginContext } from 'pinia'
import { JobAction } from "@/interface/job";
import { isDevReadOnly } from "~/modules/core/utils/devStoreOverride";
function MyPiniaPlugin({ store }: PiniaPluginContext) {


  if (store.$id == 'jobs') {
    const offlineService = useOffline()
    const fb_realtimeDatabase = useFirebase()    

    //window.ABC_RICE = store
    setTimeout(() => {
        restore()
    }, 6000);
    // jobs from my machine sync to cloud
    store.$onAction(({
      name, // name of the action
      store, // store instance, same as `someStore`
      args, // array of parameters passed to the action
      after, // hook after the action returns or resolves
      onError, // hook if the action throws or rejects
    }) => {


      let job = args[0];
      let syncToCloud = args[1];
      if (name == 'add' && syncToCloud) {
        saveJobToCloud(job)
      }

    })

    function saveJobToCloud(job) {
      // dev สวมร้านอื่น = ดูอย่างเดียว ไม่เขียน jobchain และไม่เก็บลง offline queue
      // (ไม่งั้น restore() จะพยายามดันขึ้นซ้ำทุก boot)
      if (isDevReadOnly()) return
      // โหมด Audit ดูอย่างเดียว — $onAction ยิงก่อนตัว action jobs.add จึงต้องกันที่นี่ด้วย
      // (ตัว add เองบล็อก + แจ้งผู้ใช้อยู่แล้ว ตรงนี้เงียบ ๆ)
      if (isAuditMode()) return
      let key = utilsJobKey(job);
      let type = 'job';
      let payload = {
        data: {
          ...job,
          nonce: store.nonce
        },
        type: type,
        key: key
      };
      offlineService.save(key, type, payload)
      const jobChainRef = fb_realtimeDatabase.jobchainRef()
      let job_timestamp_ref = child(jobChainRef, key)

      set(job_timestamp_ref, payload.data)
        .then(() => {
          offlineService.release(key)
        })
        .catch((error) => {
          // ห้ามกลืน error ตรงนี้เด็ดขาด — firebase เขียนแบบ optimistic
          // UI จะขึ้นออเดอร์ให้แล้วแต่ server ปฏิเสธและ rollback เงียบ ๆ
          // ถ้าไม่แจ้ง แคชเชียร์จะขายต่อทั้งวันแล้วข้อมูลหายตอน reload
          // (offlineService ยังเก็บ job ไว้ ไม่ได้ release จึงไม่หายจากเครื่อง)
          useRtdbGuardStore().reportJobchainFailure('saveJobToCloud', error)
        })

    }


    function restore() {
      if (isDevReadOnly()) return

      let jobs = offlineService.getItemsByType('job')
      const storeId = useStoreId()
      jobs.forEach(job => {
        if(job.data.storeId != storeId){
          return
        }
        const jobChainRef = fb_realtimeDatabase.jobchainRef()
        let job_timestamp_ref = child(jobChainRef, job.key)
        set(job_timestamp_ref, job.data)
          .then(() => {
            offlineService.release(job.key)
          })
          .catch((error) => {
            useRtdbGuardStore().reportJobchainFailure('restore', error)
          })
      })
    }


  }

}

export default defineNuxtPlugin(({ $pinia }) => {
  $pinia.use(MyPiniaPlugin)
})